import { shouldRenderHomeOnSuccess } from '@organisms/HomeTab/homeUtils';
import ScreenNames from '@navigation/navigationConstants';
import secureStore from '@utils/secureStore';
import tokenManager from '@utils/secureStore/tokenManager';

type MeApiData = {
  phoneNumber: string;
  firstName: string;
  lastName: string;
  // Add other properties used inside shouldRenderHomeOnSuccess if needed
};

export function renderHomePageOnAutoLogin(
  isSuccess: boolean,
  meApiData: MeApiData | null | {},
  setLoginData: (data: { mobileNumber: string }) => void,
  setAccounts: Function,
  setSelectedAccount: Function,
  setCanShowReferral: Function,
  setEmployeeId: Function,
  setIsInLockPeriod: Function,
  setReferralApplicable: Function,
  setStatus: Function,
  setUserId: Function,
  setEmployerId: Function,
  setBPAccounts: Function,
  setSelectedBPAccounts: Function,
  setBPPhone: Function,
  setIsSuspended: Function,
  setOtpData: (data: { userName: string }) => void,
  setHeaderText: Function,
  setReferralHeaderText: Function,
  setAppliedReferral: Function,
  setTxnSuccessReferral: Function,
  setMeAmplitudeContext: Function,
  setAutoDisburseData: Function,
  navigation?: { navigate: (routeName: string, params?: Record<string, any>) => void },
): void {
  if (isSuccess && meApiData) {
    const { phoneNumber, firstName, lastName } = meApiData;
    const userName = `${firstName}${lastName}`;
    setLoginData({ mobileNumber: phoneNumber });
    setOtpData({ userName });

    shouldRenderHomeOnSuccess({
      meApiData,
      isSuccess,
      setAccounts,
      setSelectedAccount,
      setCanShowReferral,
      setEmployeeId,
      setIsInLockPeriod,
      setReferralApplicable,
      setStatus,
      setUserId,
      setEmployerId,
      setBPAccounts,
      setSelectedBPAccounts,
      phoneNumber,
      userName,
      setBPPhone,
      setIsSuspended,
      setHeaderText,
      setReferralHeaderText,
      setAppliedReferral,
      setTxnSuccessReferral,
      setMeAmplitudeContext,
      setAutoDisburseData,
    });

    if (navigation) {
      navigation.navigate(ScreenNames.PIN_ENFORCE_GATE);
    }
  }
}

export async function autoLoginIfCorrectTokens(search: string, refetch: () => void): Promise<void> {
  if (search) {
    const params = new URLSearchParams(search);
    const accessToken = params.get('accessToken');
    const refreshToken = params.get('refreshToken');

    if (accessToken && refreshToken) {
      await secureStore.setItemAsync('accessToken', accessToken);
      await secureStore.setItemAsync('refreshToken', refreshToken);
      tokenManager.setAccessToken(accessToken);
      tokenManager.setRefreshToken(refreshToken);
      refetch();
    }
  }
}
